import {isThrottlingError} from '../utils/HttpUtils';
import {RootScope} from '../types/angular-types';

function LoggingHttpInterceptorFactory($q, $window, $location, $rootScope: RootScope, ClientMetricsService) {
    const clientLogoUrlRegEx = /^https:\/\/s3.amazonaws.com\/amazonworkdocs.com\/client-logos.*/;
    
    var addAjaxCallLogsMetricService = function(logMessage) {
        ClientMetricsService.addToAjaxCallEvents(angular.extend(logMessage, {
            path: $location.url(),
            timestamp : new Date().toISOString()
        }));                    
    };
    
    function getMethodNameForStatus(statusCode: number) {
        if (statusCode >= 400 && statusCode < 500) {
            return "Ajax.4xxError";
        }
        if (statusCode >= 500) {
            return "Ajax.5xxError";
        }
        return "Ajax." + statusCode + "Error";
    }

    function isValidUrl(url: string) {
        return !clientLogoUrlRegEx.test(url) && url.indexOf("https://") === 0;
    }

    return {
        // record request errors
        'requestError': function(rejection) {
            if (!rejection.headers) {
                //For syntax errors in JSON response, we don't get response.config object
                return;
            }
            var requestId = rejection.headers()['x-amzn-requestid'] || 'none';
            addAjaxCallLogsMetricService({ 
                event: "AJAX_CALL_ERROR_EVENT", 
                callUrl : rejection.config.url, 
                statusCode: rejection.status,
                method: rejection.config.method, 
                requestId : requestId
            });
            $rootScope.metricServiceInstance.newCounterMetric("Ajax.RequestError");
            return $q.reject(rejection);
        },

        // record response error
        'responseError': function(rejection) {
            if (!rejection.headers) {
                //For syntax errors in JSON response, we don't get response.config object
                return;
            }
            if (isValidUrl(rejection.config.url)) {
                // redact authentication to avoid it from being logged
                if (rejection.config.headers && rejection.config.headers.Authentication) {
                    rejection.config.headers.Authentication = '****-****';
                }
                var requestId = rejection.headers()['x-amzn-requestid'] || 'none';
                addAjaxCallLogsMetricService({
                    event: "AJAX_CALL_ERROR_EVENT",
                    callUrl : rejection.config.url,
                    metadata: rejection.statusText,
                    statusCode: rejection.status,
                    method: rejection.config.method,
                    requestId: requestId
                });
                $rootScope.metricServiceInstance.newCounterMetric(getMethodNameForStatus(rejection.status));
                if (isThrottlingError(rejection)) {
                    $rootScope.metricServiceInstance.newCounterMetric('Ajax.Throttle');
                }
                if (rejection.status >= 400) {
                    $rootScope.metricServiceInstance.newCounterMetric("Ajax." + rejection.status + "Error");
                }
            }
            return $q.reject(rejection);
        },
        // optional method
        'response': function(response) {
            if (!response.headers) {
                //For syntax errors in JSON response, we don't get response.config object
                return;
            }
            //If it is not absolute url, it is not Ajax call to service. The call may be initiated to load template by ng-include
            if (isValidUrl(response.config.url)) {
                // redact authentication to avoid it from being logged
                if (response.config.headers && response.config.headers.Authentication) {
                    response.config.headers.Authentication = '****-****';
                }
                // do something on success
                var requestId = response.headers()['x-amzn-requestid'] || 'none';
                addAjaxCallLogsMetricService({
                    event: "AJAX_CALL_COMPLETE_EVENT", 
                    callUrl : response.config.url, 
                    statusCode: response.status, 
                    metadata: response.statusText,
                    method: response.config.method, 
                    requestId: requestId 
                });
                $rootScope.metricServiceInstance.newCounterMetric("Ajax.RequestSuccess");
            }
            return response;
        },
    };
};


//Register the interceptor as a service to log all Ajax call errors as these affect site availability
//VERY IMPORTANT: This interceptor should be registered with $httpProvider after the AuthService interceptor, as the latter does behind the scenes token refresh

angular.module('GorillaBoy.common')
.factory('LoggingHttpInterceptor', LoggingHttpInterceptorFactory);
LoggingHttpInterceptorFactory.$inject = ["$q", "$window", "$location", "$rootScope", "ClientMetricsService"];

//Don't push interceptor here, all interceptors are ordered in the app.module.ts config() callback function

export default LoggingHttpInterceptorFactory;

